module.exports = __webpack_public_path__ + "img/vvip-daily-perks.a71adfda.webp";